__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "cv_mfe_react";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@cv-mf/portfolio-services", "0.0.1", () => (__webpack_require__.e(464).then(() => (() => (__webpack_require__(9464))))));
			register("@cv-mf/portfolio-types", "0.0.1", () => (__webpack_require__.e(918).then(() => (() => (__webpack_require__(5918))))));
			register("@cv-mf/portfolio-web-components", "0.0.1", () => (Promise.all([__webpack_require__.e(797), __webpack_require__.e(362)]).then(() => (() => (__webpack_require__(7362))))));
			register("@cv-mf/remote-utils", "0.0.1", () => (__webpack_require__.e(443).then(() => (() => (__webpack_require__(3443))))));
			register("@cv-mf/services", "0.0.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
			register("@cv-mf/shared-web-components", "0.0.1", () => (Promise.all([__webpack_require__.e(797), __webpack_require__.e(519)]).then(() => (() => (__webpack_require__(6519))))));
			register("@cv-mf/types", "0.0.1", () => (__webpack_require__.e(585).then(() => (() => (__webpack_require__(4585))))));
			register("@cv-mf/utils", "0.0.1", () => (__webpack_require__.e(58).then(() => (() => (__webpack_require__(9058))))));
			register("@cv-mf/web-components", "0.0.1", () => (Promise.all([__webpack_require__.e(797), __webpack_require__.e(926)]).then(() => (() => (__webpack_require__(926))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};